import Form from "react-bootstrap/Form";
import { parse } from "papaparse";
import React, { useRef, useState } from "react";
import { PanssParameters } from "../types/PanssParameters.type";
import { predictPanss } from "../services/PanssService";
import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";
import { PanssResult } from "../types/PanssResults.type";
import { useTranslation } from "react-i18next";
import "../styles/Forms.css";
function ExcelUploadForm() {
    const [t, i18n] = useTranslation("global");
    const navigate = useNavigate();
    const [data, setData] = useState<PanssParameters | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [validated, setValidated] = useState(false);
    const [fileError, setFileError] = useState(false);
    const [loading, setLoading] = useState(false);

    const inputRef = useRef<HTMLSelectElement>(null);
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (file && file.name.toLowerCase().endsWith(".csv")) {
            const reader = new FileReader();
            setSelectedFile(file);
            setFileError(false);
            reader.onload = (event) => {
                const csvData = event.target!.result as string;
                parse(csvData, {
                    header: true,
                    complete: (results) => {
                        const parsedData = results.data as PanssParameters[];
                        setData(parsedData[0]);
                    },
                });
            };

            reader.readAsText(file);
            console.log(data);
        } else {
            setSelectedFile(null);
            setFileError(true);
        }
    };
    const handlePredictAndNavigate = async (e: any) => {
        e.preventDefault();
        setLoading(true);

        if (data != null) {
            const panssResults = await predictPanss(data);
            if (inputRef.current) {
                inputRef.current.value = "";
            }

            navigate("results", {
                state: {
                    panssResults,
                },
            });
        }
    };
    return (
        <>
            {/* GIF de carga (Overlay) */}
            {loading && (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <img
                        src="https://i.gifer.com/ZZ5H.gif"
                        alt={t("buttons.loading")}
                        style={{ width: "80px", height: "80px" }}
                    />
                </div>
            )}
            <div className="d-flex justify-content-center mt-5">
                <Form onSubmit={handlePredictAndNavigate} className="w-75">
                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label>{t("excel.import")}</Form.Label>

                        <Form.Control
                            ref={inputRef}
                            required
                            type="file"
                            isInvalid={
                                fileError || (validated && !selectedFile)
                            }
                            onChange={handleFileChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            {fileError
                                ? t("upload.error.extension-csv")
                                : t("upload.error.required")}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button
                        variant="primary"
                        type="submit"
                        className="custom-button w-100"
                        disabled={loading}
                    >
                        {loading ? t("buttons.loading") : t("buttons.submit")}
                    </Button>
                </Form>
            </div>
        </>
    );
}
export default ExcelUploadForm;
